import Link from "next/link"

export default function AdditionalInformation({ links, className }) {
  return links?.length ? (
    <div className={`additional-info max-w-[300px] px-5 xl:px-7 xl:ml-5 py-8 ${className}`}>
      <h3 className="font-primary text-m1 font-semibold pb-5">Additional Information</h3>
      <ul className="flex flex-col gap-5 list-none">
        {links?.map(({ full_slug, name }) => (
          <li key={`${full_slug}-link`}>
            <Link href={`/${full_slug}`} className="underline hover:no-underline text-primary capitalize">
              {name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  ) : null
}
